<script setup>
  import { ref, onMounted, watch, watchEffect, computed} from 'vue';
  import { useUserStore } from '@/stores/UserStore'
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore';
  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';

  const emits = defineEmits(['close']);
  const props = defineProps({
    profileId: {
      type: Number,
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();
  const googleAnalyticsStore = useGoogleAnalyticsStore();

  const profileName = ref(``);
  const showModal = ref(false);

  const currentProfileName = computed(() => userStore.getProfileById(props.profileId).name)

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function updateProfileName() {
    await userStore.updateProfile(props.profileId, profileName.value);

    googleAnalyticsStore.sendEvent('User_Profile_Edit');

    await userStore.getProfiles(true);

    if (jwc) {
      jwc.toaster.toast({
        type: 'success',
        content: `Renamed profile to ${profileName.value}`
      })
    }    

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  })

  watch(() => props.profileId, () => {
    profileName.value = userStore.getProfileById(props.profileId).name;
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
  >
    <ModalContentTextInput
      v-model="profileName"
      :modalTitle="`Rename ${currentProfileName}`"
      labelText="Name"
      acceptButtonText="Save"
      @accept="updateProfileName"
      @cancel="closeModal"
    /> 
  </BaseModal>
</template>